import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {environment} from '../../../../environments/environment';

export interface ProcedureCrosswalk {
  procedureCrosswalkId?: number;
  version: number;
  rplCode: string;
  rplDescription?: string;
  primaryDiagnosisCode: string;
  diagnosisDescription?: string;
  ccsaCode: string | null;
  ccsaDescription?: string;
  minimumAge: number | null;
  maximumAge: number | null;
  ageUnit: 'DAYS' | 'YEARS' | null;
  notes?: string;
  requiresClinicalReview: boolean;
  active: boolean;
  updated?: string;
  updatedBy?: string;
}

@Injectable({providedIn: 'root'})
export class ProcedureCrosswalkService {
  private readonly url = environment.baseUrl + '/procedure-crosswalk';
  constructor(private http: HttpClient) {}

  list(search: string, offset: number, limit: number): Observable<{items: ProcedureCrosswalk[]; total: number}> {
    const request = new PagedRequestDTO();
    request.entityClass = 'TblProcedureCrosswalk';
    request.pageNumber = Math.floor(offset / limit);
    request.pageSize = limit;
    request.sortField = 'procedureCrosswalkId';
    request.sortDirection = 'ASC';
    request.fieldMap = {};
    if (search.trim()) {
      for (const name of ['rplCode', 'primaryDiagnosisCode', 'ccsaCode']) {
        request.fieldMap[name] = {name, operator: 'like', value: search.trim(), logicGate: name === 'rplCode' ? 'and' : 'or'};
      }
    }
    return this.http.post<PagedResponseDTO<ProcedureCrosswalk>>(this.url + '/filter', request)
      .pipe(map(page => ({items: page.resultList, total: page.totalRecords})));
  }

  save(row: ProcedureCrosswalk): Observable<ProcedureCrosswalk> {
    return this.http.post<ProcedureCrosswalk>(this.url + '/save', row);
  }
}
